import { render, staticRenderFns } from "./Watchdetail-child1.vue?vue&type=template&id=8235a30e&scoped=true"
import script from "./Watchdetail-child1.vue?vue&type=script&lang=js"
export * from "./Watchdetail-child1.vue?vue&type=script&lang=js"
import style0 from "./Watchdetail-child1.vue?vue&type=style&index=0&id=8235a30e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8235a30e",
  null
  
)

export default component.exports